export const INIT_SETTINGS = '@@settings/INIT_SETTINGS'
export const SET_SETTING   = '@@settings/SET_SETTING'

export enum SettingsActionTypes {
    INIT_SETTINGS = '@@settings/INIT_SETTINGS',
    SET_SETTING   = '@@settings/SET_SETTING',
}


// WEBPACK FOOTER //
// ./src/modules/settings/store/types.ts